export default {
  "SorryPage.DocumentTitle": "Consents regarding the handling of Personal Data",
  "SorryPage.ContainerContentPc1":
    "We were unable to obtain your consents due to system maintenance",
  "SorryPage.ContainerContentPc2": " ",
  "SorryPage.ContainerContentPc3": " ",
  "SorryPage.ContainerContent1":
    "We were unable to obtain your consents due to system maintenance",
  "SorryPage.ContainerContent2": " ",
  "SorryPage.ContainerContent3": " ",
  "SorryPage.ContainerContent4": " ",
  "SorryPage.ContainerContentTextSorry1": " ",
  "SorryPage.ContainerContentTextSorry2":
    "Please wait a few minutes before you try again",
}
